module.exports = __webpack_public_path__ + "img/eur.88adaf28.png";